import React, { useState, useEffect } from "react";
import HomeBanner from "./HomeBanner";
import HomeFinance from "./HomeFinance";
import HomeServices from "./HomeServices";
import HomeAbout from "./HomeAbout";
import HomeContact from "./HomeContact";
import Footer from "./Footer";
import CalendarPopup from "./Popup";
import HomeBlog from "./HomeBlog";
import Header from "./Header";
import PopupForm from "./Booking";
import "../styles/Home.css";

const Home = () => {
  const [popupState, setPopupState] = useState(null);

  useEffect(() => {
    // ✅ global runtime flag (resets on refresh)
    if (!window.__calendarPopupOpened__) {
      window.__calendarPopupOpened__ = true;
      setPopupState("calendar");
    }
  }, []);

  const handleClose = () => setPopupState(null);

  return (
    <div>
      {/* {popupState === "calendar" && (
        <CalendarPopup
          onClose={handleClose}
          onOpenBooking={() => setPopupState("booking")}
        />
      )} */}

      {popupState === "booking" && (
        <PopupForm isOpen={true} onClose={handleClose} />
      )}

      <HomeBanner />
      <HomeFinance />
      <HomeServices />
      <HomeAbout />
      <HomeBlog />
      <HomeContact />
    </div>
  );
};

export default Home;
